import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type FilterIconProps = Omit<BaseIconProps, 'children' | 'hasLegacyStrokeStyles'>;

export const FilterIcon = ({ strokeWidth, ...props }: FilterIconProps) => (
  <BaseIcon
    width={24}
    height={24}
    viewBox="0 0 18 14"
    fill="#141B4D"
    strokeWidth={strokeWidth}
    fillRule="evenodd"
    clipRule="evenodd"
    title="Filter Icon"
    desc="An icon representing the concept of filtering"
    {...props}
  >
    <path d="M6 4C6.55228 4 7 3.55228 7 3C7 2.44772 6.55228 2 6 2C5.44772 2 5 2.44772 5 3C5 3.55228 5.44772 4 6 4ZM6 0C7.30622 0 8.41746 0.834808 8.82929 2L17 2C17.5523 2 18 2.44772 18 3C18 3.55229 17.5523 4 17 4H8.82929C8.41746 5.16519 7.30622 6 6 6C4.69378 6 3.58254 5.16519 3.17071 4H1C0.447715 4 0 3.55228 0 3C0 2.44772 0.447715 2 1 2H3.17071C3.58254 0.834808 4.69378 0 6 0ZM14.8293 10C14.4175 8.83481 13.3062 8 12 8C10.6938 8 9.58254 8.83481 9.17071 10H1C0.447715 10 0 10.4477 0 11C0 11.5523 0.447715 12 1 12H9.17071C9.58254 13.1652 10.6938 14 12 14C13.3062 14 14.4175 13.1652 14.8293 12H17C17.5523 12 18 11.5523 18 11C18 10.4477 17.5523 10 17 10H14.8293ZM13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11C11 11.5523 11.4477 12 12 12C12.5523 12 13 11.5523 13 11Z" />
  </BaseIcon>
);

FilterIcon.displayName = 'FilterIcon';
